<template>
	<div>
		<div class="post" v-for="post in posts">
			<img class="paperclip" src="/static/main/img/paperclip.png" alt="paperclip" />
			<a :href="'/#/posts/' + post.slug"><img :src="post.cover_thumb" v-if="post.cover_thumb != null"></a>
			<a :href="'/#/posts/' + post.slug"><h5>{{ post.title }}</h5></a>
			<i>{{ post.created_at }}</i>
			<!-- <img src="http://dnz-kalynka.pp.ua/media/cache/51/80/51809b1e04918ed6855d029af92eb570.jpg"> -->
			<p>
				<span v-html="post.text_truncated">{{ post.text_truncated }}</span>
				<a :href="'/#/posts/' + post.slug">Читати далі</a>
			</p>
		</div>
	</div>
</template>

<script type="text/javascript">

	module.exports = {
		data: function(){
			return {
				main: 'https://dnz-kalynka.pp.ua/api/posts/',
				posts: []
			}
		},
		methods: {
			getContent: function(){
				var postId = this.$route.params.id
				this.$http.get(this.main).then(function(response){
					this.posts = response.data
					// console.log(response.data)
				}, function(error){
					console.log('Помилка при отриманні даних')
				})
			}
		},
		created: function(){
			this.getContent()
		},
		watch: {
			'$route': {
				deep: true,
					handler: function (refreshPage) {
					this.getContent()
				}
			}
		}
	}

</script>


// WEBPACK FOOTER //
// src/views/posts.vue